import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "m10.235 10.833.85-.85L8.602 7.5V4h-1.2v4zM8.002 14.4q-1.323 0-2.487-.5a6.5 6.5 0 0 1-2.038-1.375 6.5 6.5 0 0 1-1.375-2.041 6.3 6.3 0 0 1-.5-2.492q0-1.325.5-2.492a6.4 6.4 0 0 1 1.375-2.033A6.5 6.5 0 0 1 5.517 2.1a6.3 6.3 0 0 1 2.492-.5q1.326 0 2.493.504a6.5 6.5 0 0 1 2.03 1.368 6.5 6.5 0 0 1 1.366 2.032q.504 1.168.504 2.496a6.2 6.2 0 0 1-.5 2.486 6.5 6.5 0 0 1-1.367 2.039A6.35 6.35 0 0 1 8.002 14.4m.008-1.2q2.157 0 3.675-1.525 1.516-1.525 1.517-3.683t-1.517-3.675T8.01 2.8q-2.16 0-3.683 1.517-1.525 1.516-1.525 3.675t1.525 3.683Q5.85 13.2 8.01 13.2" }, null, -1)
  ]))]))
}
export default { render: render }